import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const TalkTrackIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M25.414 3.758a2 2 0 0 0-2.828 0l-2.829 2.828A2.002 2.002 0 0 0 19.44 7H12V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V9h7.439a2 2 0 0 0 .318.415l.707.707-10.343 10.343-.707-.707a2 2 0 0 0-2.828 0l-2.829 2.828a2 2 0 0 0 0 2.829l2.829 2.828a2 2 0 0 0 2.828 0l2.829-2.828c.126-.127.233-.267.318-.415H20v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1h-7.439a1.998 1.998 0 0 0-.318-.414l-.708-.707 10.343-10.343.708.707a2 2 0 0 0 2.828 0l2.829-2.828a2 2 0 0 0 0-2.829l-2.829-2.828ZM26.828 8 24 10.83 21.172 8 24 5.172 26.828 8ZM10 6v4H6V6h4Zm16 20h-4v-4h4v4ZM8 21.172 10.83 24 8 26.83 5.172 24 8 21.172Z" />
  </BaseIcon>
);
